export const CONTROLS_ERROR :string  = "controlsError";

export const VALUE_CHANGED_SYNC:string = "valueChangedSync";

export const FUNCTION_STRING:string = "function";

export const OBJECT_STRING:string = "object";

export const RX_WEB_VALIDATOR:string = "rxwebValidator";

export const NUMBER:string = "number";

export const BOOLEAN:string = "boolean";

export const CUSTOM:string = "custom";

export const TEMPLATE_VALIDATION_CONFIG:string = "template-validation-config"; 

export const CONDITIONAL_VALIDATOR:string = "conditionalValidator"

export const VALIDATOR_CONFIG: string = "validatorConfig";

export const THIS: string = "this";

export const RXCODE:string = "-rxw-";

export const MODEL:string = "model";

export const MODEL_INSTANCE: string = "modelInstance";

export const PATCH: string = "patch";

